'use strict';

import { CoreRepository } from '../CoreRepository';
import { IndPhone } from '../../Entities/Ind/IndPhone';
import { IndPhoneCollection } from '../../Collections/Ind/IndPhoneCollection';

export class IndPhoneRepository extends CoreRepository {
  public getIndPhones(indId: number, options: object = {}, criteria: object = null) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI.getIndPhones(indId, options).then((response) => {
      const collection = new IndPhoneCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new IndPhone();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public createIndPhone(indId: number, payload: any[]) {
    return this.webAPI.createIndPhone(indId, payload).then((response) => {
      const indPhone = new IndPhone();
      indPhone.hydrate(response);

      return indPhone;
    });
  }

  public removeIndPhone(indId: number, indPhoneId: number) {
    return this.webAPI.removeIndPhone(indId, indPhoneId).then((response) => {
      return response;
    });
  }

  public updateIndPhone(indId: number, indPhoneId: number, payload: any[]) {
    return this.webAPI.updateIndPhone(indId, indPhoneId, payload).then((response) => {
      return response;
    });
  }

  public moveIndPhone(individualId: number, individualPhoneId: number, payload: any[]) {
    return this.webAPI.moveIndPhone(individualId, individualPhoneId, payload).then((response) => {
      return response;
    });
  }
}
